import React, { useState } from "react";
import { motion } from "framer-motion";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import Union from "../../assets/Union.png";
import { useTranslation } from "react-i18next";

const Transperency = () => {
  const { t } = useTranslation();

  // State to manage the current page
  const [currentPage, setCurrentPage] = useState(0);

  // Content for each page
  const pages = [
    {
      heading: {
        part1: t("transperency.heading.part1"),
        part2: t("transperency.heading.part2"),
        part3: t("transperency.heading.part3"),
        part4: t("transperency.heading.part4"),
      },
      paragraphs: [
        t("transperency.content.paragraph1"),
        t("transperency.content.paragraph2"),
        t("transperency.content.paragraph3"),
      ],
    },
    {
      heading: {
        part1: t("transperency1.heading.part1"),
        part2: "",
        part3: "",
        part4: "",
      },
      paragraphs: [
        t("transperency1.content.newText.paragraph1"),
        t("transperency1.content.newText.paragraph2"),
        t("transperency1.content.newText.paragraph3"),
      ],
    },
    {
      heading: {
        part1: t("transperency2.heading.part1"),
        part2: "",
        part3: "",
        part4: "",
      },
      paragraphs: [
        t("transperency2.content.newText.paragraph1"),
        t("transperency2.content.newText.paragraph2"),
        t("transperency2.content.newText.paragraph3"),
      ],
    },
  ];

  // Function to handle page change
  const handlePageChange = (direction) => {
    setCurrentPage((prevPage) => {
      const newPage = prevPage + direction;
      if (newPage < 0 || newPage >= pages.length) return prevPage; // Prevent out-of-bounds
      return newPage;
    });
  };

  return (
    <section className="bg-gray-50 py-16 px-6 md:px-12 lg:px-24">
      <div className="max-w-6xl mx-auto">
        {/* Heading Section */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="font-arya text-3xl md:text-4xl font-bold mb-4">
            {pages[currentPage].heading.part1 && (
              <span className="text-green-700">{pages[currentPage].heading.part1}</span>
            )}
            {pages[currentPage].heading.part2 && ` ${pages[currentPage].heading.part2}`}
            {pages[currentPage].heading.part3 && <br />}
            {pages[currentPage].heading.part3 && pages[currentPage].heading.part3}
            {pages[currentPage].heading.part4 && (
              <>
                , <span className="text-green-700">{pages[currentPage].heading.part4}</span>
              </>
            )}
          </h2>
        </motion.div>

        {/* Content Section */}
        <div className="grid md:grid-cols-2 gap-10 items-center">
          {/* Image Section */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="p-3 rounded-lg inline-block">
              <img src={Union} alt="Drone inspection" className="rounded-md object-cover" />
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            {/* Render content based on the current page */}
            {pages[currentPage].paragraphs.map((paragraph, index) => (
              <p key={index} className="text-gray-600 mb-4">
                {paragraph}
              </p>
            ))}

            {/* Pagination Buttons */}
            <div className="flex gap-3 justify-center md:justify-start">
              <button
                className={`w-10 h-10 flex items-center justify-center rounded-full shadow transition ${
                  currentPage === 0
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-green-700 text-white hover:bg-green-800"
                }`}
                onClick={() => handlePageChange(-1)}
                disabled={currentPage === 0}
              >
                <AiOutlineLeft size={15} />
              </button>
              <button
                className={`w-10 h-10 flex items-center justify-center rounded-full shadow transition ${
                  currentPage === pages.length - 1
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-green-700 text-white hover:bg-green-800"
                }`}
                onClick={() => handlePageChange(1)}
                disabled={currentPage === pages.length - 1}
              >
                <AiOutlineRight size={15} />
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Transperency;
